export default {
  'form-basic-form.basic.title': '基礎表單',
  'form-basic-form.basic.description':
    '表單頁用於向用戶收集或驗證信息，基礎表單常見於數據項較少的表單場景。',

  'form-basic-form.email.required': '請輸入郵箱地址！',
  'form-basic-form.email.wrong-format': '郵箱地址格式錯誤！',
  'form-basic-form.userName.required': '請輸入賬戶!',
  'form-basic-form.password.required': '請輸入密碼！',
  'form-basic-form.password.twice': '兩次輸入的密碼不匹配!',
  'form-basic-form.strength.msg': '請至少輸入 6 個字符。請不要使用容易被猜到的密碼。',
  'form-basic-form.strength.strong': '強度：強',
  'form-basic-form.strength.medium': '強度：中',
  'form-basic-form.strength.short': '強度：太短',
  'form-basic-form.confirm-password.required': '請確認密碼！',
  'form-basic-form.phone-number.required': '請輸入手機號！',
  'form-basic-form.phone-number.wrong-format': '手機號格式錯誤！',
  'form-basic-form.verification-code.required': '請輸入驗證碼！',
  'form-basic-form.title.required': '請輸入標題',
  'form-basic-form.date.required': '請選擇起止日期',
  'form-basic-form.goal.required': '請輸入目標描述',
  'form-basic-form.standard.required': '請輸入衡量標淮',

  'form-basic-form.form.get-captcha': '獲取驗證碼',
  'form-basic-form.captcha.second': '秒',
  'form-basic-form.form.optional': '（選填）',
  'form-basic-form.form.submit': '提交',
  'form-basic-form.form.save': '保存',
  'form-basic-form.email.placeholder': '郵箱',
  'form-basic-form.password.placeholder': '至少6位密碼，區分大小寫',
  'form-basic-form.confirm-password.placeholder': '確認密碼',
  'form-basic-form.phone-number.placeholder': '手機號',
  'form-basic-form.verification-code.placeholder': '驗證碼',
  'form-basic-form.title.label': '標題',
  'form-basic-form.title.placeholder': '給目標起個名字',
  'form-basic-form.date.label': '起止日期',
  'form-basic-form.placeholder.start': '開始日期',
  'form-basic-form.placeholder.end': '結束日期',
  'form-basic-form.goal.label': '目標描述',
  'form-basic-form.goal.placeholder': '請輸入妳的階段性工作目標',
  'form-basic-form.standard.label': '衡量標淮',
  'form-basic-form.standard.placeholder': '請輸入衡量標淮',
  'form-basic-form.client.label': '客戶',
  'form-basic-form.label.tooltip': '目標的服務對象',
  'form-basic-form.client.placeholder': '請描述妳服務的客戶，內部客戶直接 @姓名／工號',
  'form-basic-form.invites.label': '邀評人',
  'form-basic-form.invites.placeholder': '請直接 @姓名／工號，最多可邀請 5 人',
  'form-basic-form.weight.label': '權重',
  'form-basic-form.weight.placeholder': '請輸入',
  'form-basic-form.public.label': '目標公開',
  'form-basic-form.label.help': '客戶、邀評人默認被分享',
  'form-basic-form.radio.public': '公開',
  'form-basic-form.radio.partially-public': '部分公開',
  'form-basic-form.radio.private': '不公開',
  'form-basic-form.publicUsers.placeholder': '公開給',
  'form-basic-form.option.A': '同事甲',
  'form-basic-form.option.B': '同事乙',
  'form-basic-form.option.C': '同事丙',
};
